import { render, staticRenderFns } from "./institutions.vue?vue&type=template&id=f1b2ac48&scoped=true"
import script from "./institutions.vue?vue&type=script&lang=js"
export * from "./institutions.vue?vue&type=script&lang=js"
import style0 from "./institutions.vue?vue&type=style&index=0&id=f1b2ac48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b2ac48",
  null
  
)

export default component.exports